import { Form, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useResponsive from '../../hooks/useBreakpoint';

const ExpertSearchBox = ({ item, updateSearchParams, searchParams }) => {
  const [searchValue, setSearchValue] = useState('');
  const { serviceCategoryList, locationList, subCategoryList } = useSelector(state => state.common);
  const { rateTypeList } = useSelector(state => state.expert);
  const [options, setOptions] = useState({});
  const breakpoint = useResponsive();
  const dispatch = useDispatch();
  const { expertListSearchParams } = useSelector(state => state.expert);
  useEffect(() => {
    setOptions({
      location_id: [
        { value: '', label: '' },
        ...(locationList?.map(item => ({ value: item.id, label: item.name })) || []),
      ],

      rate_type_id: [
        { value: '', label: '' },
        ...(rateTypeList?.map(item => ({ value: item.id, label: item.name })) || []),
      ],

      category_id: [
        { value: '', label: '' },
        ...(serviceCategoryList?.map(item => ({ value: item.id, label: item.name })) || []),
      ],

      sub_category_id: [
        { value: '', label: '' },
        ...(subCategoryList?.data?.map(item => ({ value: item.id, label: item.name })) || []),
      ],
    });
  }, [locationList, rateTypeList, serviceCategoryList, subCategoryList]);

  useEffect(() => {
    // if (searchValue) {
    updateSearchParams({ ...searchParams, [item.key]: searchValue ? searchValue : '' } );
    // }
  }, [searchValue]);
  useEffect(() => {
    updateSearchParams({ ...searchParams, [item.key]: expertListSearchParams[item.key] });
  },[])
  return (
    <div
      style={{
        width:
          item.key == 'pricing_range_from' || item.key == 'pricing_range_to'
            ? breakpoint == 'lg' || breakpoint == 'md' || breakpoint == 'xs' || breakpoint == 'sm'
              ? '100%'
              : '50%'
            : '100%',
        marginTop:
          breakpoint == 'lg' || breakpoint == 'md' || breakpoint == 'xs' || breakpoint == 'sm'
            ? '0px'
            : '10px',
        display: 'inline-block',
      }}
    >
      <label
        style={{
          display: 'block',
          marginBottom:
            breakpoint == 'lg' || breakpoint == 'md' || breakpoint == 'xs' || breakpoint == 'sm'
              ? '2px'
              : '5px',
        }}
      >
        {item.placeholder}
      </label>
      {item.type == 'text' ? (
        <Input
          onChange={e => setSearchValue(e.target.value)}
          type={item.type}
          placeholder={item.placeholder}
          value={searchParams[item.key]}
          disabled={
            !searchParams['rate_type_id']
              ? item.key == 'pricing_range_from' || item.key == 'pricing_range_to'
              : false
          }
        />
      ) : (
        <Select
          onChange={e => setSearchValue(e)}
          style={{ width: '100%' }}
          placeholder={item.placeholder}
          optionLabelProp="label"
          options={options[item.key]}
          disabled={!options[item.key]?.length}
          value={searchParams[item.key]}
          defaultValue={{ value: '', label: '' }}
        />
      )}
    </div>
  );
};

export default ExpertSearchBox;
